import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { AbstractDataService } from '@zero/shared/util-abstract-services';
import { filter, skipWhile } from 'rxjs';

@Component({
  selector: 'trade-secure-tan-hint',
  templateUrl: './secure-tan-hint.component.html',
  imports: [AsyncPipe, NgbAlertModule, TranslocoPipe],
})
export class SecureTanHintComponent {
  readonly #dataService = inject(AbstractDataService);

  public shouldDisplayHint$ = this.#dataService.getEnrolledDevices$().pipe(
    skipWhile((devices) => !devices),
    filter((devices) => !devices.length),
  );
}
